<template>
  <div>
    <v-container>
      <v-card tile flat class="my-5">
        <v-card-text class="pa-0">
          <v-row no-gutters>
            <v-col cols="2" class="bg-kiri"></v-col>
            <v-col cols="10" class="pa-5">
              <h2 class="black--text">Pengawas yang Anda Pilih</h2>
              <template v-if="pengawas !== null">
                <template v-if="Object.keys(pengawas).length">
                  <p class="body-2 mt-1 mb-0">
                    Berikut adalah data pengawas yang Anda pilih untuk menjadi peserta PKP 2
                  </p>
                  <v-list class="py-0">
                    <v-list-item class="px-0">
                      <v-list-item-content>
                        <v-row no-gutters>
                          <v-col cols="12" md="5">
                            <v-list-item class="px-0">
                              <v-list-item-avatar color="blue">
                                <v-icon dark>mdi-account</v-icon>
                              </v-list-item-avatar>
                              <v-list-item-content class="py-0 px-1">
                                <v-list-item-title>
                                  <v-label color="caption"><small>Nama Lengkap Pengawas</small></v-label>
                                </v-list-item-title>
                                <div class="blue--text body-1 font-weight-medium">
                                  {{ pengawas.nama_lain || $getDeepObj(pengawas, 'ptk.nama') || '-' }}
                                </div>
                                <div class="black--text">
                                  <v-icon color="success" small dark left>
                                    mdi-whatsapp
                                  </v-icon>
                                  <span>{{ pengawas.no_wa || $getDeepObj(pengawas, 'ptk.no_hp') || '-' }}</span>
                                </div>
                              </v-list-item-content>
                            </v-list-item>
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-list-item class="px-0">
                              <v-list-item-content class="py-0">
                                <v-list-item-title>
                                  <v-label color="caption"><small>SIMPKB ID / Nomor UKG</small></v-label>
                                </v-list-item-title>
                                <div class="link black--text body-2">
                                  <div>{{
                                    pengawas.nama_lain
                                      ? pengawas.ptk_id_lain
                                        ? pengawas.ptk_id_lain
                                        : '-'
                                      : pengawas.ptk_id || '-'
                                  }}</div>
                                </div>
                              </v-list-item-content>
                            </v-list-item>
                          </v-col>
                          <v-col cols="12" md="3">
                            <v-list-item class="px-0">
                              <v-list-item-content class="py-0">
                                <v-list-item-title>
                                  <v-label color="caption"><small>Alamat Surel</small></v-label>
                                </v-list-item-title>
                                <div class="link black--text body-2">
                                  <div>{{ pengawas.email || $getDeepObj(pengawas, 'ptk.alt_email') || '-' }}</div>
                                </div>
                              </v-list-item-content>
                            </v-list-item>
                          </v-col>
                        </v-row>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                  <div v-if="false">
                    <v-list-item class="px-0">
                      <v-list-item-avatar color="white">
                        <v-icon dark></v-icon>
                      </v-list-item-avatar>
                      <v-list-item-content class="py-0">
                        <div>
                          <v-btn depressed dark color="red" @click="onAddPengawas">
                            <v-icon left>mdi-pencil</v-icon> Ganti Pengawas
                          </v-btn>
                        </div>
                      </v-list-item-content>
                    </v-list-item>
                  </div>
                </template>
                <template v-else>
                  <p v-if="!tutup" class="body-2 mt-1 mb-2">
                    Silakan pilih data pengawas yang akan Anda pilih untuk menjadi peserta PKP 2
                  </p>
                  <p v-else class="body-2 mt-1 mb-2 orange--text">
                    {{ tutup }}
                  </p>
                  <v-btn :disabled="!!tutup" depressed class="white--text" color="green" @click="onAddPengawas">
                    <v-icon left>mdi-account</v-icon> Pilih Pengawas
                  </v-btn>
                </template>
              </template>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-container>
    <base-modal-full ref="modal" title="Pengajuan Pengawas PKP Angkatan 2" @save="onSavePengawas">
      <form-pengawas ref="pengawas" />
    </base-modal-full>
  </div>
</template>

<script>
import FormPengawas from './Formulir';
import { mapActions } from 'vuex';

export default {
  name: 'PengawasIndex',
  components: { FormPengawas },
  data() {
    return {
      pengawas: null,
      tutup: '',
    };
  },
  mounted() {
    this.load();
  },
  methods: {
    ...mapActions('dppPengawas', ['fetch', 'actions']),

    async load() {
      const { psp_diklat_pengawas, tutup } = await this.fetch();
      this.pengawas = psp_diklat_pengawas || {};
      this.tutup = tutup || '';
    },

    onAddPengawas() {
      this.$refs.modal.open();
      this.$nextTick(() => {
        this.$refs.pengawas.reset(this.pengawas);
      });
    },

    onSavePengawas() {
      const error = this.$refs.pengawas.getError();
      const pengawas = this.$refs.pengawas.getValue();
      const endpoint = 'save';
      let params = Object.assign({}, pengawas);

      if (error) {
        this.$error(error);
        this.$refs.modal.loading = false;
        return;
      }

      if (!params.ptk_id) {
        delete params['ptk_id'];
      }

      this.actions({ endpoint, params })
        .then(() => {
          this.$success('Data pengawas berhasil disimpan');
          this.$refs.modal.close();
          this.load();
        })
        .catch(() => {
          this.$refs.modal.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.bg-kiri {
  background: #bbdefb;
}
</style>
